import { apiSlice } from "..";
import { getToken } from "shared/utils/getToken";

export interface AnaliseProvaTecnicaRegistro {
  idAnaliseProvaTecnica: number;
  idCandidato: number;
  classificacao: number;
  candidatoNome: string;
  candidatoSemestreAtual: number;
  provaNota: number;
  provaTempoGasto: string;
  provaNotaCorteSituacao: string;
  provaIntegridade: string;
  provaDataConclusao: string;
  provaLink: string;
}

export interface AnaliseProvaTecnicaResponse {
  totalElementos: number;
  quantidadePaginas: number;
  pagina: number;
  tamanho: number;
  elementos: AnaliseProvaTecnicaRegistro[];
}

export interface AnaliseProvaTecnicaPagination {
  pagina: number;
  tamanho?: number;
  nomeCandidato?: string;
}

const analiseProvaTecnicaSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAnaliseProvaTecnica: builder.query<
      AnaliseProvaTecnicaResponse,
      AnaliseProvaTecnicaPagination
    >({
      query: ({ pagina, tamanho = 10, nomeCandidato }) => ({
        url: "analise-prova-tecnica",
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: {
          pagina,
          tamanho,
          ...(nomeCandidato ? { nomeCandidato } : {}),
        },
      }),
      providesTags: ["AnaliseProvaTecnica"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAnaliseProvaTecnicaQuery } = analiseProvaTecnicaSlice;
